var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.0088 8.63585C26.1727 9.41678 26.8663 10.2445 27.0894 11.119C27.4279 12.4457 28.5089 23.7131 27.05 24.7168C25.591 25.7204 21.6314 25.293 16.0533 26.077C10.4752 26.8609 6.27035 28.604 4.85447 27.6509C3.4386 26.6977 1.32329 16.1241 1.3511 14.5785C1.36964 13.5481 1.89053 12.5915 2.91379 11.7087C1.55253 11.3488 0.773506 10.4687 0.576715 9.06851C0.287086 7.00769 2.66617 1.6347 11.8946 0.148745C11.7345 0.677409 11.684 1.24731 11.7657 1.82874C12.006 3.53868 13.3184 4.83747 14.9398 5.15788C15.3237 7.23335 17.3013 8.65384 19.4389 8.35342C20.2008 8.24635 20.8829 7.93471 21.4361 7.48281C22.2967 8.36581 23.5607 8.84124 24.8862 8.65495C24.9273 8.64917 24.9682 8.6428 25.0088 8.63585Z",
    fill: "#5555FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.f647965673bc64645132d520dd8ca6d8.svg";
export { ForwardRef as ReactComponent };